<template>
  <div class="assetTable">
    <slot-table :data="tableData" :columns="table.columns">
      <template slot="path" slot-scope="props">
         <div v-if="isEditMode">
            <a href="#" @click.prevent="selectFile(props.item.file)">
            <div v-if="props.item.asset_type === 'video'">
              <div class="asset__video" :video-url="props.item.path">
                 <video width="320" height="240" controls playsinline="true" :poster="assetUrl(props.item.thumb)" preload="none" controlslist="nodownload">
                  <source :src="assetUrl(props.item.path)" type="video/mp4">
                Your browser does not support the video tag.
                </video>
              </div>
              <button class="btn btn-primary" style="margin: 9px;"> Select</button>
            </div>
              <div v-if="props.item.asset_type === 'audio'">
              <div>
                <audio controls v-if="props.item.path">
                <source v-bind:src="assetUrl(props.item.path)" type="audio/mpeg" />
              Your browser does not support the video tag.
                </audio>
              </div>
                <button class="btn btn-primary" style="margin: 9px;"> Select</button>
              </div>
              <div v-else>
                <div v-if="props.item.asset_type === 'image'">
              <div class="asset__img">
                <img :src="assetUrl(props.item.path)" @error="loadDefaultImage" class="asset__img">
              </div>
              <button class="btn btn-primary" style="margin: 9px;"> Select</button>
            </div>
              </div>
          </a>
         </div>
          <div v-else>
            <div v-if="props.item.asset_type === 'video'">
              <div class="asset__video" :video-url="props.item.path" :key="props.item.path">
                <!--<img :src="assetUrl(props.item.thumb)" class="asset__img">-->
                <!--<span class="asset__video__play"><i class="fa fa-play"></i></span>-->
                <video width="320" height="240" controls playsinline="true" :poster="assetUrl(props.item.thumb)" preload="none" controlslist="nodownload">
                  <source :src="assetUrl(props.item.path)" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
            <div v-if="props.item.asset_type === 'audio'">
              <div>
                <audio controls v-if="props.item.path">
                <source v-bind:src="assetUrl(props.item.path)" type="audio/mpeg" />
              Your browser does not support the video tag.
                </audio>
              </div>
            </div>
          <div v-else>
           <div v-if="props.item.asset_type === 'image'">
            <div class="asset__img">
                <img :src="assetUrl(props.item.path)" @error="loadDefaultImage" class="asset__img">
                <div id="imageCover"></div>
            </div>
           </div>
            </div>
          </div>
      </template>

      <template slot="file" slot-scope="props">
        <input v-if="props.item.file === inlineEditFileName" type="text" v-model="inlineEditNewFileName">
        <span v-else>
            {{ props.item.file }}
        </span>
      </template>

      <template slot="size" slot-scope="props">
        <span>
            {{ Number(props.item.size) | prettyBytes }}
        </span>
      </template>

      <template slot="actions" slot-scope="props">
        <div v-if="!isEditMode" class="action-buttons">
        <div v-if="props.item.file === inlineEditFileName" class="action-buttons-margin">
          <button class="btn-xs btn btn-success" @click="onUpdateFileName(inlineEditFileName, inlineEditNewFileName)">
            <i class="fa fa-check" aria-hidden="true"></i>
          </button>
          <button @click="cancelEditFileName" class="btn btn-xs btn-primary ml-4">
                <i  class="fa fa-times"></i>
          </button>
        </div>
        <button @click="editFile(props.item.file)" v-else class="btn btn-warning btn-xs action-buttons-margin">
          <i  class="fa fa-edit" aria-hidden="true"></i>
        </button>
        <span>
            <button  @click="deleteFile(props.item.file)" class="btn btn-xs btn-danger"><i class="fa fa-trash"></i></button>
        </span>
      </div>
      </template>
    </slot-table>
  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {assetMixin} from '@/mixins/assetMixin'

import { API_URL, AWS_S3_BUCKET } from '@/config'

export default {
  name: 'AssetTable',
  mixins: [assetMixin],
  components: {
    SlotTable,
    ButtonCta,
    Field,
    SwitchButton,
    Checkbox,
    Heading
  },
  props: {
    tableData: Array,
    confirmId: parent.confirmId,
    type: String
  },
  data: () => ({
    inlineEditFileName: null,
    inlineEditNewFileName: null,
    table: {
      columns: {
        path: 'Preview',
        file: 'Filename',
        width: 'Width (px)',
        height: 'Height (px)',
        mimetype: 'Mimetype',
        size: 'Size',
        actions: ''
      }
    }
  }),
  computed: {
    isEditMode: function () {
      return this.confirmId
    }
  },
  methods: {
    assetUrl (path) {
      if (this.type === 'after-effects') {
        return `${AWS_S3_BUCKET}${path.charAt(0) === '/' ? path.substring(1).replace('store/', '') : path.replace('store/', '')}?ts=` + Math.round(+new Date() / 1000) // need to remove leading slash
      }
      return `${API_URL}${path.charAt(0) === '/' ? path.substring(1) : path}?ts=` + Math.round(+new Date() / 1000) // need to remove leading slash
    },
    deleteFile (file) {
      this.$emit('deleteFile', file)
    },
    onUpdateFileName (inlineEditFileName, inlineEditNewFileName) {
      console.log(inlineEditNewFileName)
      if (inlineEditFileName && inlineEditNewFileName) {
        this.$emit('onUpdateFileName', { inlineEditFileName, inlineEditNewFileName })
        this.cancelEditFileName()
      } else {
        console.error('file name must have values')
      }
    },
    previewFile (path) {
      window.open(path, '_blank')
    },
    selectFile (file) {
      this.$emit('selectFile', file)
    },
    loadDefaultImage (e) {
      e.target.src = 'https://via.placeholder.com/500x50/2c3247/56ffa2?text=No+Preview+Available'
    },
    editFile (file) {
      // console.log('file', file)
      this.inlineEditFileName = file
      this.inlineEditNewFileName = file
    },
    cancelEditFileName () {
      this.inlineEditFileName = null
    }
  }
}
</script>

<style lang="scss">
      .asset__img{
        display: none;
      }
    .asset__img, .asset__video {
      display: none;
      background-color: #ccc;
      background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
      background-size: 10px 10px;
      background-position: 0 0, 5px 5px;
      padding: 0px;
      max-width: 200px;
      max-height: 200px;
      img, video {
        object-fit: scale-down;
        border:2px solid #2c3247;
      }
      & #imageCover {
        z-index:50;
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(123,123,123,0);
      }
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .asset__video {
      background-color: black;
      max-width: 320px;
      max-height: 320px;
    }
    .top-buffer {
      margin-top:10px;
    }
    .action-buttons {
    display: flex;
    align-items: center;
   }
  .action-buttons-margin {
    margin-right: 7px;
   }
</style>



// WEBPACK FOOTER //
// src/components/AssetTable/asset-table.vue